var EmailDashboardModule = (function () {
    function EmailDashboardModule() {
    }
    return EmailDashboardModule;
}());
export { EmailDashboardModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.module.ts.pre-build-optimizer.js